import { getAuthAxiosBackend } from "@/helpers/axios"

class AlmelakatServices {
    get(id) {
        return getAuthAxiosBackend().get('Almelakat/getAlmelakatById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Almelakat/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Almelakat/addAlmelakat', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Almelakat/updateAlmelakat/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Almelakat/restoreAlmelakat' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Almelakat/softDeleteAlmelakat/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Almelakat/deleteAlmelakat/' + id.toString())
    }
}

export default new AlmelakatServices()
